import { getEventDetails, getEvents } from '../../data/events';

// Event layers
const loadEventDetail = async (event_id) => {
  return await getEventDetails(event_id);
}

export const loadEvents = async (
  route, events, dispatch,
  worker, isInitialLoad = true, trackedEventsRef,
  ensureEventId = null
) => {
  // DBC22-7055: route set before first load done; polling feed lacks locations
  if (trackedEventsRef && !Object.keys(trackedEventsRef.current).length) {
    isInitialLoad = true;
  }

  // Fetch data
  const eventData = await getEvents(!isInitialLoad);

  // Use detail endpoint on cache miss (new events)
  if (ensureEventId && !eventData.some(event => event.id == ensureEventId)) {
    try {
      eventData.push(await loadEventDetail(ensureEventId));

    } catch (e) {
      // missing/unreachable → Map stale-link msg
    }
  }

  // Track unfiltered events' highlight status and last_updated timestamp
  const trackedEventsDict = eventData.reduce((acc, event) => {
    const trackedEvent = (trackedEventsRef && trackedEventsRef.current[event.id]) ?
      trackedEventsRef.current[event.id] : null;

    if (trackedEvent) {
      event.location = trackedEvent.location;
      event.polygon = trackedEvent.polygon;
    }

    acc[event.id] = {
      location: event.location,
      polygon: event.polygon,
      highlight: trackedEvent ? event.last_updated !== trackedEvent.last_updated || trackedEvent.highlight : !isInitialLoad,
      last_updated: event.last_updated
    };

    // Set the updated flag if the event has been updated since the initial load
    event.highlight = acc[event.id].highlight;

    return acc;
  }, {});

  // Fetch locations for events that were newly added from polling calls
  for (const event of eventData) {
    if (!event.location) {
      const eventDetails = await loadEventDetail(event.id);
      event.location = eventDetails.location;
      trackedEventsDict[event.id].location = eventDetails.location;

      event.polygon = eventDetails.polygon;
      trackedEventsDict[event.id].polygon = eventDetails.polygon;
    }
  }

  if (trackedEventsRef) {
    // Remove items that no longer exist
    Object.keys(trackedEventsRef.current).forEach((key) => {
      if (!trackedEventsDict[key]) {
        delete trackedEventsRef.current[key];
      }
    });

    trackedEventsRef.current = trackedEventsDict;
  }

  // Trigger filter worker
  worker.postMessage({ data: eventData, route: route, action: 'updateEvents' });
};
